export const DIETA = [
  {
    id: 1,
    name: "Грибной суп-пюре",
    ingredients:
      "ИНГРЕДИЕНТЫ лесные грибы – 500 г питьевая вода – 1 л веточка тимьяна – 1 шт. чеснок – 1 зубчик оливковое масло – 2 ст. л. сливочное масло – 40 г сливки жирностью не меньше 20% – 300 мл мука – 3 ст. л. соль, свежемолотый белый перец – по вкусу",
    steps: [
      {
        id: 1,
        image: "https://www.gastronom.ru/binfiles/images/20220905/b1c04c1b.jpg",
        description:
          "Шаг 1 Грибной сюп-пюре Подготовьте грибы для варки супа-пюре. Почистите их и вымойте или протрите влажной салфеткой. Отрежьте у грибов ножки и крупно порубите их. Шляпки нарежьте тонкими ломтиками.",
      },
      {
        id: 2,
        image: "https://www.gastronom.ru/binfiles/images/20220905/b9074ff0.jpg",
        description:
          "Шаг 2 Чеснок очистите и раздавите плоской стороной ножа. Ножки грибов переложите в кастрюлю и залейте холодной питьевой водой. Добавьте тимьян и чеснок. Доведите до кипения, варите на небольшом огне под крышкой 30 минут.",
      },
      {
        id: 3,
        image: "https://www.gastronom.ru/binfiles/images/20220905/b1e2d7fc.jpg",
        description:
          "Шаг 3 В большой сковороде нагрейте половину оливкового масла. Положите нарезанные шляпки грибов, посолите по вкусу и закройте крышкой. Готовьте на сильном огне, потряхивая сковороду, 5 минут.",
      },
      {
        id: 4,
        image: "https://www.gastronom.ru/binfiles/images/20220905/b7ad94df.jpg",
        description:
          "Шаг 4 Грибной сюп-пюре Откройте крышку: в сковороде должен образоваться грибной сок. Аккуратно вычерпайте его в кастрюлю, где варятся ножки. Добавьте оставшееся оливковое масло, перемешайте и жарьте грибы, помешивая, еще 10 минут.",
      },
      {
        id: 5,
        image: "https://www.gastronom.ru/binfiles/images/20220905/b9e6a63e.jpg",
        description:
          "Шаг 5 Грибной сюп-пюре Шляпки положите в кастрюлю с ножками в бульон за 5–10 минут до конца приготовления (тимьян и чеснок удалите). Половник бульона перелейте в ковшик и дайте слегка остыть.",
      },
      {
        id: 6,
        image: "https://www.gastronom.ru/binfiles/images/20220905/bb89e6f2.jpg",
        description:
          "Шаг 6 Грибной сюп-пюре Пока грибы довариваются, в небольшом сотейнике растопите сливочное масло. Всыпьте муку и подрумяньте, помешивая, на среднем огне в течение трех минут. Влейте из ковшика бульон. Варите, помешивая венчиком, три минуты.",
      },
      {
        id: 7,
        image: "https://www.gastronom.ru/binfiles/images/20220905/bdf166a3.jpg",
        description:
          "Шаг 7 Грибной сюп-пюре Перелейте бульон с грибами в блендер, добавьте мучную заправку из сотейника. Измельчите в пюре. Поставьте на огонь и, помешивая, доведите до кипения. Влейте сливки, посолите и поперчите. Доведите до кипения и сразу снимите с огня.",
      },
    ],
  },
]
